import { Slide, useScrollTrigger } from '@mui/material';

export default function HideOnScroll({ appear = false, direction, window, children }) {
  const trigger = useScrollTrigger({
    target: window ? window() : undefined
  });

  return (
    <Slide appear={appear} direction={direction} in={!trigger}>
      {children}
    </Slide>
  );
}
